<script>
export default{
    mounted(){
        let userindex=JSON.parse(localStorage.getItem('userindex'))
        console.log(userindex);
        this.userindex=userindex
        this.allusers=JSON.parse(localStorage.getItem('allsignupusers')) || []
        console.log(this.allusers[userindex]);
        // this.$router.push({name:'viewpage',params:{user:this.allusers[userindex]}})
    },
    data(){
        return{
            allusers:[],
            userindex:''
        }
    },
}
</script>
<template>
    <!-- <template> -->
  <div v-if="allusers.length>0 && allusers[userindex]">
    <div>{{ allusers[userindex].fullname }}</div>
    <div>{{ allusers[userindex].email }}</div>
  </div>
</template>